import {
    useClampedPosition,
    useScrubberPreview,
} from '@features/advancedVideoPlayer/hooks';
import { FrameRate, Track } from '@features/Clip/types/media';
import { Box } from '@radix-ui/themes';
import { ScrubberPreview } from './ScrubberPreview';

import styles from './ScrubberLayer.module.css';

export interface InteractionRect {
    bottom: number | string;
    left: number | string;
    width: number | string;
    height: number | string;
}

interface ScrubberLayerProps {
    totalFrames: number;
    tracks: Track[];
    frameRate: FrameRate;
    onSeek: (frame: number) => void;
    zone: InteractionRect;
    previewOffset?: number;
    aspectRatio: number;
}

export const ScrubberLayer = ({
    totalFrames,
    tracks,
    frameRate,
    onSeek,
    zone,
    previewOffset,
    aspectRatio,
}: ScrubberLayerProps) => {
    const { containerRef, hoverData, handleMouseMove, clearHover } =
        useScrubberPreview(totalFrames);

    const containerRect = containerRef.current?.getBoundingClientRect();
    const { clampedStyle, relativePointerX } = useClampedPosition({
        position: { x: hoverData?.x },
        containerRect,
        size: { width: 160, height: 0 },
    });

    return (
        <Box
            className={styles.scrubberLayer}
            style={zone}
            ref={containerRef}
            onMouseMove={handleMouseMove}
            onMouseLeave={clearHover}
            onClick={() => hoverData && onSeek(hoverData.frame)}
        >
            {hoverData && (
                <Box
                    className={styles.scrubberBox}
                    style={{
                        bottom: `${previewOffset}px`,
                        ...clampedStyle,
                    }}
                >
                    <ScrubberPreview
                        frame={hoverData.frame}
                        tracks={tracks}
                        frameRate={frameRate}
                        pointerOffset={relativePointerX}
                        aspectRatio={aspectRatio}
                    />
                </Box>
            )}
        </Box>
    );
};
